module.exports = __webpack_public_path__ + "img/s11-txt4.02bc03bd.png";